//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { fetch, store, update } from '@/apis/administrators'

export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            name: [{ required: true, message: '請輸入名稱！' }],
            username: [{ required: true, message: '請輸入帳號！' }],
        };
        const formData = {
            name: "",
            username: "",
            password: "",


        };
        return {
            id: 0,
            fileLoading: false,
            businessHours: '',
            //是否為管理員
            isAdmin: false,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            previewImage: undefined,
            previewVisible: false
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;
        if (this.id > 0) {
            await this.onPageLoad();
        }

    },
    methods: {
        async onPageLoad() {
            try {
                const res = await fetch(this.id);
                if (res.code == 200) {
                    if (['admin'].includes(res.data.username)) { 
                        this.isAdmin = true;
                    }
                    this.formData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },


        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        async onSubmit(e) {
            let formFunction;
            const form = { ...this.formData };
            if (this.id > 0) {
                form.id = this.id;
                formFunction = update;
            } else {
                formFunction = store;
            }
            try {
                this.spinning = true;
                const res = await formFunction(form);
                if (res.code == 200) {
                    this.$message.success('提交完成');
                    this.$router.push('/administrators');
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
